import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import SectorMain from '../components/sections/SectorMain'
import Sector01 from '../components/sections/Sector01'
import Sector02 from '../components/sections/Sector02'
import Sector03 from '../components/sections/Sector03'
import Sector04 from '../components/sections/Sector04'
import Sector05 from '../components/sections/Sector05'
import SectorContact from '../components/sections/SectorContact'
import SectorApply from '../components/sections/SectorApply'
// import Sector01First from '../components/sections/Sector01-1'
// import Sector01Second from '../components/sections/Sector01-2'
import { menuItems } from '../constants/navigation'
import '../styles/common.css'
import { motion, AnimatePresence } from 'framer-motion'

function Home() {
  const location = useLocation();
  const [currentSection, setCurrentSection] = useState(0);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  // 초기 로드 시 window.scrollTo(0, 0)를 직접 호출하여 페이지 맨 위로 강제 이동
  useEffect(() => {
    // 페이지 로드 시 맨 위로 스크롤
    window.scrollTo(0, 0);
    
    // URL에서 모든 상태 정리
    if (window.history.replaceState) {
      window.history.replaceState({}, '', window.location.pathname);
    }
    
    // 페이지가 새로 로드된 것인지 확인 (새로고침, 직접 URL 접근 등)
    const isPageReload = !sessionStorage.getItem('userInitiatedScroll');
    
    if (isPageReload) {
      // 새로 로드된 경우, 스크롤을 맨 위로 유지
      console.log('페이지 새로 로드: 자동 스크롤 비활성화');
      setIsFirstLoad(true);
      
      // 0.8초 후에 isFirstLoad를 false로 설정 (모든 애니메이션이 완료될 시간)
      setTimeout(() => {
        setIsFirstLoad(false);
      }, 800);
    } else {
      // 사용자가 명시적으로 네비게이션을 클릭한 경우
      console.log('사용자 네비게이션: 스크롤 허용');
      setIsFirstLoad(false);
      sessionStorage.removeItem('userInitiatedScroll');
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const currentSectionIndex = Math.floor(scrollPosition / windowHeight);
      setCurrentSection(currentSectionIndex);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // 명시적으로 isFirstLoad가 false이고 location에 scrollTarget이 있는 경우에만 스크롤 허용
    if (isFirstLoad || !location.state?.scrollTarget) {
      return;
    }

    const handleNavigation = () => {
      const target = location.state?.scrollTarget;

      if (target) {
        console.log(`Home: 네비게이션 대상 - ${target} (사용자 요청)`);
        
        setTimeout(() => {
          const element = document.querySelector(target);
          if (element) {
            // 헤더 높이 계산
            const headerHeight = document.querySelector('.main_hd')?.offsetHeight || 80;
            
            // 요소 위치 계산 - 다양한 방법으로 시도
            const offsetTop = element.offsetTop;
            
            console.log(`Home: 스크롤 목표 - ${offsetTop - headerHeight}px`);
            
            // 스크롤 이동 (offsetTop 사용)
            window.scrollTo({
              top: offsetTop - headerHeight,
              behavior: 'smooth'
            });
          } else {
            console.warn(`Home: Navigation target not found - ${target}`);
          }
        }, 600);
      }
    };

    handleNavigation();
  }, [location, isFirstLoad]);

  const motionProps = {
    initial: { y: 100, opacity: 0 },
    whileInView: { y: 0, opacity: 1 },
    viewport: { once: true },
    transition: {
      type: "spring",
      duration: 1.5,
      bounce: 0.4,
      stiffness: 60,
      damping: 20
    }
  };

  return (
    <div className="container">
      <Header menuItems={menuItems} />
      <main role="main">
        <AnimatePresence mode="wait">
          <motion.div
            key="home"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <SectorMain motionProps={motionProps} />
            {/* <Sector01 motionProps={motionProps} /> */}
            {/* <Sector01First motionProps={motionProps} />
            <Sector01Second motionProps={motionProps} /> */}
            
            {/* <Sector02 motionProps={motionProps} />
            <Sector03 motionProps={motionProps} />
            <Sector04 motionProps={motionProps} />
            <Sector05 motionProps={motionProps} /> */}

            <SectorContact motionProps={motionProps} />
            <SectorApply motionProps={motionProps} />
          </motion.div>
        </AnimatePresence>
      </main>
      <Footer />
    </div>
  )
}

export default Home